import type { INotificationRepository } from '../repositories/INotificationRepository.js';

interface Deps { notificationRepository: INotificationRepository; }

export function createGetUnreadCountUseCase({ notificationRepository }: Deps) {
  return function getUnreadCount(projectId?: string): Promise<number> {
    return notificationRepository.unreadCount(projectId);
  };
}
